import styled, { css } from 'styled-components';
import { DraggingContainerProps } from './HBTable.types';
import { absoluteAll, scrollShadow } from '../../styles/mixins';
import { Transform } from '@dnd-kit/utilities';

// This object is not an attempt to create a design system level z-idex hierarchy and should not be used outside the table.
// It's just here to make the relationship between the different table components is easier to reason about.

export const TABLE_ROW_BG_COLOR_VAR = '--hb-table-row-bg-color';

export const TABLE_Z_INDEX = {
    BOTTOM: 1,
    MIDDLE: 2,
    TOP: 3
} as const;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
`;

export const getColumnTransform = (
    transform: Transform | null,
    isPinnedColumn: boolean
) => {
    if (transform && !isPinnedColumn) {
        return `translateX(${transform.x}px)`;
    }
    return 'none';
};

export const draggingContainerStyles = css<DraggingContainerProps>`
    transition: ${({ $transition }) => $transition};
    position: relative;
    z-index: ${({ $isDragging }) => ($isDragging ? 1 : null)};
`;

export const DraggingShadow = styled.div<DraggingContainerProps>`
    ${absoluteAll}
    height: calc(100% + 1px);
    display: ${({ $isDragging }) => ($isDragging ? 'block' : 'none')};
    opacity: 0.3;

    ${scrollShadow({
        isShadowActive: true,
        size: 15,
        direction: 'right'
    })}
    ${scrollShadow({
        isShadowActive: true,
        size: 15,
        direction: 'left'
    })}
`;
